import IcSave from './IcSave'

export default IcSave
